import { render, staticRenderFns } from "./StudyListTable.vue?vue&type=template&id=0fa27542&scoped=true&lang=pug"
import script from "./StudyListTable.vue?vue&type=script&lang=ts"
export * from "./StudyListTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyListTable.vue?vue&type=style&index=0&id=0fa27542&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa27542",
  null
  
)

export default component.exports